<script lang="ts">
  import { page } from '$app/stores';
  import { WalletConnectButton } from '@features/wallet-connect-button';

  $: galleryName = $page.data.configurations.name;
</script>

<section>
  <p class="mb-6 text-base">
    To purchase Digital Originals of artworks and to participate in {galleryName} auctions, you need to connect your cryptocurrency
    wallet that supports the Ethereum network with the ERС-20 standard.
  </p>

  <p class="mb-6 text-base">
    For the best experience, you should use a browser on a PC, for example,
    <a href="https://www.google.com/chrome/" target="_blank" class="underline"> Google Chrome. </a>
  </p>

  <div class="mb-4">
    <WalletConnectButton />
  </div>
</section>
